export class Tooltip {
    /**
    * Create a tooltip for an inputfield
    * @param {HTMLElement} element Tooltip
    */
    constructor (element) {
        // Name, reference
        element.Tooltip = this;

        element.setAttribute('title', element.innerText);
        element.innerText = '';

        // Make it visible
        element.classList.remove('is-hidden');
    }
}
